import React from 'react';
import {Box, ButtonBase, CircularProgress, Typography, useTheme} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {AddressSearchMode, AddressSearchTypeSelectorProps} from './types';
import {Container, Tab} from './styles';
import Icon from 'presentation/icons';

const {searchByZipCode, myLocation} =
	translations['pt-br'].privateFlow.profile.changeData.address.searchTypeSelector;

export function AddressSearchTypeSelector({
	selectedMode,
	onModeChange,
	isLocating = false,
	isLocationBlocked = false,
}: AddressSearchTypeSelectorProps) {
	const theme = useTheme();

	const getLocationColor = () => {
		if (isLocationBlocked) {
			return theme.palette.text.disabled;
		}

		if (selectedMode === AddressSearchMode.CURRENT_LOCATION) {
			return theme.palette.primary.main;
		}

		return theme.palette.text.secondary;
	};

	const handleSelect = (mode: AddressSearchMode) => {
		if (mode !== selectedMode) {
			onModeChange(mode);
		}
	};

	const isZipCodeActive = selectedMode === AddressSearchMode.ZIP_CODE;
	const isLocationActive = selectedMode === AddressSearchMode.CURRENT_LOCATION;
	const zipCodeColor = isZipCodeActive
		? theme.palette.primary.main
		: theme.palette.text.secondary;
	const locationColor = getLocationColor();

	return (
		<Box role="tablist" aria-label="Tipo de busca de endereço" sx={Container}>
			<ButtonBase
				role="tab"
				aria-selected={isZipCodeActive}
				onClick={() => handleSelect(AddressSearchMode.ZIP_CODE)}
				sx={Tab(isZipCodeActive)}>
				<Icon
					name="position-focused"
					size={20}
					color={zipCodeColor}
					style={{transition: 'fill 0.2s ease'}}
				/>
				<Typography
					variant="body2"
					fontWeight={600}
					noWrap
					sx={{color: zipCodeColor, transition: 'color 0.2s ease'}}>
					{searchByZipCode}
				</Typography>
			</ButtonBase>

			<ButtonBase
				role="tab"
				aria-selected={isLocationActive}
				disabled={isLocating}
				onClick={() => handleSelect(AddressSearchMode.CURRENT_LOCATION)}
				sx={Tab(isLocationActive)}>
				{isLocating ? (
					<CircularProgress size={16} color="inherit" />
				) : (
					<Icon
						name={isLocationBlocked ? 'location-blocked' : 'location-default'}
						size={20}
						color={locationColor}
						style={{transition: 'fill 0.2s ease'}}
					/>
				)}
				<Typography
					variant="body2"
					fontWeight={600}
					noWrap
					sx={{color: locationColor, transition: 'color 0.2s ease'}}>
					{myLocation}
				</Typography>
			</ButtonBase>
		</Box>
	);
}
